/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_Right_SlightInputs */

const vi_shop_home_pos_right_slight = /** @type {(inputs: Shop_Home_Pos_Right_SlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hơi lệch phải`)
};

/**

* @param {Shop_Home_Pos_Right_SlightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_right_slight = /** @type {((inputs?: Shop_Home_Pos_Right_SlightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_Right_SlightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_right_slight(inputs)
});